/**
 * Scene unit configuration.
 *
 * One world-unit equals one base unit (default: 1 meter).
 * Changing `BASE_UNIT` rescales the grid, snap increments, and any
 * other derived constants so the scene stays coherent.
 */

export interface UnitDef {
  /** Display label (e.g. "Meters") */
  label: string;
  /** Short abbreviation (e.g. "m") */
  abbr: string;
  /** How many meters one base unit equals (meter = 1, foot ≈ 0.3048) */
  metersPerUnit: number;
}

export const UNIT_METER: UnitDef = {
  label: "Meters",
  abbr: "m",
  metersPerUnit: 1,
};
export const UNIT_FOOT: UnitDef = {
  label: "Feet",
  abbr: "ft",
  metersPerUnit: 0.3048,
};
export const UNIT_CENTIMETER: UnitDef = {
  label: "Centimeters",
  abbr: "cm",
  metersPerUnit: 0.01,
};

/** Active base unit. */
export const BASE_UNIT: UnitDef = UNIT_METER;

/** Grid cell size in world units (1 base unit). */
export const GRID_CELL = 1;

/** Total grid extent in world units. */
export const GRID_EXTENT = 200;

/** Number of grid divisions (GRID_EXTENT / GRID_CELL). */
export const GRID_DIVISIONS = GRID_EXTENT / GRID_CELL;

/** Snap increment for grid snapping (equals one grid cell). */
export const SNAP_INCREMENT = GRID_CELL;

/** Axis line half-length (matches grid half-extent). */
export const AXIS_LINE_HALF = GRID_EXTENT / 2;
